'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _userservice = require('./userservice');

var _userservice2 = _interopRequireDefault(_userservice);

var _helpers = require('../common/helpers');

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiService = function ApiService() {
	_classCallCheck(this, ApiService);

	this.createMeetingRequest = function (options) {
		return new Promise(function (resolve, reject) {
			var joinChatUrl = "/v1/help/add";
			(0, _helpers.ajax)(joinChatUrl, 'POST', options).then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.checkMeetingStatus = function (meeting) {
		return new Promise(function (resolve, reject) {
			var checkMeetingUrl = "/v1/meeting/" + meeting + "/info";
			(0, _helpers.ajax)(checkMeetingUrl, 'GET').then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.joinMeetingRequest = function (meeting) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return new Promise(function (resolve, reject) {
			var joinMeetingUrl = "/v1/meeting/" + meeting + "/join";
			if (!options) {
				(0, _helpers.ajax)(joinMeetingUrl, 'POST').then(function (res) {
					return resolve(res);
				}).catch(function (err) {
					return reject(err);
				});
			} else {
				(0, _helpers.ajax)(joinMeetingUrl, 'POST', options).then(function (res) {
					return resolve(res);
				}).catch(function (err) {
					return reject(err);
				});
			}
		});
	};

	this.leaveMeetingRequest = function (meeting) {
		return new Promise(function (resolve, reject) {
			var leaveMeetingUrl = "/v1/meeting/" + meeting + "/leave";
			(0, _helpers.ajax)(leaveMeetingUrl, 'POST').then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.endMeetingRequest = function (meeting) {
		return new Promise(function (resolve, reject) {
			var endMeetingUrl = "/v1/meeting/" + meeting + "/end";
			(0, _helpers.ajax)(endMeetingUrl, 'POST').then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.getMeetingHistoryMessages = function (meetingId, historyMessagesUrl) {
		return new Promise(function (resolve, reject) {

			if (!historyMessagesUrl) {
				historyMessagesUrl = "/v1/chat/" + meetingId + "/history";
				(0, _helpers.ajax)(historyMessagesUrl, 'GET').then(function (res) {
					return resolve(res);
				}).catch(function (err) {
					return reject(err);
				});
			} else {

				(0, _helpers.ajax)(historyMessagesUrl, 'GET', null, false).then(function (res) {
					return resolve(res);
				}).catch(function (err) {
					return reject(err);
				});
			}
		});
	};

	this.getContacts = function () {
		return new Promise(function (resolve, reject) {
			var getContactsUrl = "/v1/contact/list";
			(0, _helpers.ajax)(getContactsUrl, 'GET').then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.getMeetingParticipants = function (meetingId) {
		return new Promise(function (resolve, reject) {
			var getParticipantsUrl = "/v1/meeting/" + meetingId + "/participants";
			(0, _helpers.ajax)(getParticipantsUrl, 'GET').then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.updatePushNotificationToken = function (token) {
		return new Promise(function (resolve, reject) {
			var notificationUrl = '/v1/device/' + _userservice2.default.getSessionId() + '/update';
			(0, _helpers.ajax)(notificationUrl, 'POST', token).then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.getLiveChats = function () {
		return new Promise(function (resolve, reject) {
			var liveChatUrl = '/v1/meeting/live/list';
			(0, _helpers.ajax)(liveChatUrl, 'GET').then(function (res) {
				return resolve(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.getLiveVisitors = function () {
		return new Promise(function (reslove, reject) {
			var liveVisitorsUrl = '/v1/visitors/live';
			(0, _helpers.ajax)(liveVisitorsUrl, 'Get').then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.getChatReports = function (options) {
		return new Promise(function (reslove, reject) {
			var chatReportsUrl = '/v1/reports/meetings';
			(0, _helpers.ajax)(chatReportsUrl, 'POST', options).then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.chatReportsDownload = function (options) {
		return new Promise(function (resolve, reject) {
			var chatReportsDownloadUrl = '/v1/reports/meetings';
			var apiUrl = window.sfChat.baseApiUrl + chatReportsDownloadUrl;
			var headers = (0, _helpers.getAuthHeader)();
			var body = {
				method: 'POST',
				headers: headers,
				body: JSON.stringify(options)
			};
			fetch(apiUrl, body).then(function (res) {
				switch (res.status) {
					case 500:
						console.error('Some server error');
						reject(res);
						break;
					case 401:
						localStorage.removeItem(Constants.NS_USER);
						console.error('Unauthorized');
						reject(res);
						break;
					case 400:
						console.warn('Bad Request');
						reject(res);
						break;
				}
				resolve(res);
			}).catch(function (err) {
				if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object') reject(err.json());else reject(err);
			});
		});
	};

	this.chatTranscriptDownload = function (meetingId, mode) {
		return new Promise(function (resolve, reject) {
			var chatTranscriptDownloadUrl = "/v1/chat/" + meetingId + "/history";
			var apiUrl = window.sfChat.baseApiUrl + chatTranscriptDownloadUrl;
			var headers = (0, _helpers.getAuthHeader)();
			var body = {
				method: 'GET',
				headers: headers
			};
			if (mode === 'download') {
				apiUrl += "?mode=download";
			}
			fetch(apiUrl, body).then(function (res) {
				switch (res.status) {
					case 500:
						console.error('Some server error');
						reject(res);
						break;
					case 401:
						localStorage.removeItem(Constants.NS_USER);
						console.error('Unauthorized');
						reject(res);
						break;
					case 400:
						console.warn('Bad Request');
						reject(res);
						break;
				}
				resolve(res);
			}).catch(function (err) {
				if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object') reject(err.json());else reject(err);
			});
		});
	};

	this.getChatHistoryMessages = function (meetingId) {
		return new Promise(function (reslove, reject) {
			var getChatHistoryMessagesUrl = "/v1/chat/" + meetingId + "/history";
			(0, _helpers.ajax)(getChatHistoryMessagesUrl, 'GET').then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.systemInviteAcknowledge = function (url, options) {
		return new Promise(function (reslove, reject) {
			var systemInviteAcknowledgeUrl = url;
			(0, _helpers.ajax)(systemInviteAcknowledgeUrl, 'POST', options, false).then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.systemInviteJoin = function (url, options) {
		return new Promise(function (reslove, reject) {
			var getChatHistoryMessagesUrl = url;
			(0, _helpers.ajax)(getChatHistoryMessagesUrl, 'POST', options, false).then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};

	this.greetUser = function (options) {
		return new Promise(function (reslove, reject) {
			var greetUrl = "/v1/user/notify";
			(0, _helpers.ajax)(greetUrl, 'POST', options).then(function (res) {
				return reslove(res);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
};

exports.default = new ApiService();


// WEBPACK FOOTER //
// ../chat/lib/services/apiservice.js